<a class="btn-primary-container">
  <button type="button" class="btn btn-primary" [routerLink]="['', {outlets: { modal: ['preregister']}}]" skipLocationChange>
    <span i18n="PreRegistration Button@preregister.open.popup">Pre-Register now</span>
  </button>
</a>

